"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYS = {
    ESCAPE: 27,
    UP: 38,
    DOWN: 40,
    a: 65,
    ENTER: 13,
    DEL: 8,
    ENTF: 46
};
exports.MOUSEBUTTONS = {
    LEFT: 128,
    RIGHT: 512
};
var BaseSelectionBehaviour = (function () {
    function BaseSelectionBehaviour() {
        this.isCtrlClicked = false;
        this.isShiftClicked = false;
        this.isAltClicked = false;
        this.isCmdClicked = false;
        this.activeRow = undefined;
    }
    BaseSelectionBehaviour.prototype.setGrid = function (grid) {
        this._grid = grid;
    };
    BaseSelectionBehaviour.prototype.removeSelectedRow = function (row) {
        this.checkGrid();
        if (row >= 0 && row < this._grid.getGridRows()) {
            this._grid.selectedRows = _.without(this._grid.selectedRows, row);
        }
        this._grid.notifyObservers(this._grid.selectedRows);
    };
    BaseSelectionBehaviour.prototype.addSelectedRow = function (row) {
        this.checkGrid();
        if (row >= 0 && row < this._grid.getGridRows() && this._grid.selectedRows.length < this._grid.getGridRows()) {
            if (_.contains(this._grid.selectedRows, row)) {
                this._grid.selectedRows = _.without(this._grid.selectedRows, row);
            }
            this._grid.selectedRows.push(row);
        }
        this._grid.notifyObservers(this._grid.selectedRows);
    };
    BaseSelectionBehaviour.prototype.triggerRow = function (row) {
        this.checkGrid();
        if (this.isSelectedRow(row)) {
            this.removeSelectedRow(row);
        }
        else {
            this.addSelectedRow(row);
        }
        this._grid.notifyObservers(this._grid.selectedRows);
    };
    BaseSelectionBehaviour.prototype.isSelectedRow = function (row) {
        this.checkGrid();
        return _.contains(this._grid.selectedRows, row);
    };
    BaseSelectionBehaviour.prototype.getLatestRow = function () {
        this.checkGrid();
        return this._grid.selectedRows[this._grid.selectedRows.length - 1];
    };
    BaseSelectionBehaviour.prototype.getNumberOfRows = function () {
        return this._grid.getGridRows();
    };
    BaseSelectionBehaviour.prototype.moveSelectedRow = function (row, offset, keepPreviousRowSelected) {
        var nextRow = row + offset;
        if (nextRow < 0 || nextRow >= this.getGridRows()) {
            return;
        }
        if (!keepPreviousRowSelected) {
            this.clearAllSelectedRows();
        }
        this.addSelectedRow(row + offset);
    };
    BaseSelectionBehaviour.prototype.clearAllSelectedRows = function () {
        this._grid.selectedRows = new Array();
        this._grid.notifyObservers(this._grid.selectedRows);
    };
    BaseSelectionBehaviour.prototype.checkGrid = function () {
        if (this._grid === undefined) {
            throw new Error("ERROR! Grid not set in selection behaviour!");
        }
    };
    BaseSelectionBehaviour.prototype.getRow = function (event) {
        var cell = this._grid.cellByLocation(event.x, event.y);
        var pixelOffset = 5;
        if (!cell) {
            var cellLeft = this._grid.cellByLocation(event.x - pixelOffset, event.y);
            var cellRight = this._grid.cellByLocation(event.x + pixelOffset, event.y);
            if (cellLeft) {
                cell = cellLeft;
            }
            else if (cellRight) {
                cell = cellRight;
            }
        }
        if (cell) {
            return cell[0];
        }
        return undefined;
    };
    BaseSelectionBehaviour.prototype.getGridRows = function () {
        return this._grid.getGridRows();
    };
    BaseSelectionBehaviour.prototype.clearSelection = function () {
        this._grid.selectedRows = [];
        this._grid.notifyObservers(this._grid.selectedRows);
    };
    BaseSelectionBehaviour.prototype.getSelectedRows = function () {
        return this._grid.selectedRows;
    };
    BaseSelectionBehaviour.prototype.setCommandKeys = function (event) {
        this.isCtrlClicked = event.isControlPressed();
        this.isShiftClicked = event.isShiftPressed();
        this.isAltClicked = event.isAltPressed();
        this.isCmdClicked = event.isCmdPressed();
    };
    BaseSelectionBehaviour.prototype.mouseClicked = function (event) {
        throw new Error("Not implemented!");
    };
    BaseSelectionBehaviour.prototype.keyPressed = function (event) {
        this.setCommandKeys(event);
    };
    BaseSelectionBehaviour.prototype.keyReleased = function (event) {
        this.setCommandKeys(event);
    };
    return BaseSelectionBehaviour;
}());
exports.BaseSelectionBehaviour = BaseSelectionBehaviour;
//# sourceMappingURL=BaseSelectionBehaviour.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/grids/selectBehaviours/BaseSelectionBehaviour.js
// module id = 27
// module chunks = 0